import React from 'react';

const ModernButton = ({ 
  children, 
  icon, 
  onClick, 
  variant = 'default', 
  isActive = false, 
  className = '',
  ...props 
}) => {
  const baseClasses = "cursor-pointer relative inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-9 px-3";
  
  const variantClasses = {
    default: "bg-white hover:bg-[#F5F5F5]",
    primary: "bg-blue-600 text-white hover:bg-blue-700",
    secondary: "bg-gray-100 text-gray-900 hover:bg-gray-200",
    active: "bg-yellow-100 text-gray-900 border border-yellow-500 shadow-md"
  };

  const buttonClass = `${baseClasses} ${isActive ? variantClasses.active : variantClasses[variant]} ${className}`;

  return (
    <button 
      className={buttonClass}
      onClick={onClick}
      {...props}
    >
      {icon && (
        <span className="flex items-center justify-center">
          {icon}
        </span>
      )}
      {children}
    </button>
  );
};

// Navigation Button Component
const NavButton = ({ 
  children, 
  icon, 
  onClick, 
  isActive = false, 
  hoverColor = '#06B6D4',
  iconColor = '#06B6D4',
  className = '',
  ...props 
}) => {
  return (
    <button 
      className={`cursor-pointer relative inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-9 px-3 ${
        isActive 
          ? 'bg-yellow-200 text-gray-900 border border-yellow-500 shadow-md' 
          : 'bg-white hover:bg-[#F5F5F5]'
      } ${className}`}
      onClick={onClick}
      style={{
        '--hover-color': hoverColor
      }}
      onMouseEnter={(e) => {
        if (!isActive) {
          e.target.style.color = hoverColor;
        }
      }}
      onMouseLeave={(e) => {
        if (!isActive) {
          e.target.style.color = '';
        }
      }}
      {...props}
    >
      {icon && (
        <span className="flex items-center justify-center">
          {React.cloneElement(icon, { 
            stroke: isActive ? '#374151' : iconColor,
            fill: icon.props.fill || 'none'
          })}
        </span>
      )}
      {children}
    </button>
  );
};

// Back Button Component
const BackButton = ({ onClick, className = '', ...props }) => {
  return (
    <button 
      className={`relative inline-flex items-center justify-center gap-2 text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-white hover:bg-[#F5F5F5] h-9 rounded-md px-3 group ${className}`}
      onClick={onClick}
      {...props}
    >
      <svg 
        className="lucide lucide-arrow-left" 
        strokeLinejoin="round" 
        strokeLinecap="round" 
        strokeWidth={2} 
        stroke="currentColor" 
        fill="none" 
        viewBox="0 0 24 24" 
        height={22} 
        width={22} 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="m12 19-7-7 7-7" />
        <path d="M19 12H5" />
      </svg>
      <span className="origin-left scale-0 transition-transform group-hover:scale-100">
        Back
      </span>
    </button>
  );
};

export { ModernButton, NavButton, BackButton };
export default ModernButton;